package org.vreo.devicehub.features.userAuthentication.presentation.register.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Check
import androidx.compose.material.icons.filled.Close
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier

/**
 * Requirement check text, provides visual representation if condition is valid or not
 *
 * @param text text to display
 * @param valid valid state
 * @param modifier modifier
 */
@Composable
fun RequirementCheckText(
    text: String,
    valid: Boolean,
    modifier: Modifier = Modifier
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Start,
        modifier = modifier
    ) {
        Icon(
            imageVector = if (valid) {
                Icons.Default.Check
            } else {
                Icons.Default.Close
            },
            contentDescription = null,
        )

        Text(
            text = text,
            style = MaterialTheme.typography.bodySmall,
            color = if (valid) MaterialTheme.colorScheme.onSurface else MaterialTheme.colorScheme.error,
            modifier = modifier
        )
    }
}